import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Lock, Clock } from 'lucide-react';
import { Mockup3D } from './Mockup3D';
export function HeroSection() {
  const scrollToCheckout = () => {
    document.getElementById('checkout')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative pt-8 pb-24 md:pt-12 md:pb-32 overflow-hidden" data-id="element-72">
      {/* Background gradient */}
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-beige-light via-beige to-beige-dark opacity-80 -z-10" data-id="element-73"></div>

      <div className="max-w-6xl mx-auto px-6" data-id="element-74">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20" data-id="element-75">
          {/* Text Content */}
          <motion.div className="flex-1 text-center lg:text-left z-10" initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8
        }} data-id="element-76">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-serif text-navy leading-[1.1] mb-6" data-id="element-77">
              Volvé a sentir calma, claridad y control en solo 21 días
            </h1>

            <motion.div className="flex justify-center lg:justify-start mb-8" initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.15,
            duration: 0.7
          }} data-id="element-78">
              <img src="https://cdn.magicpatterns.com/uploads/dLPhzrYfB728kiphH847ss/Dada_la_imagen_de_referencia__redise_ala_un_poco__que_siga_p.png" alt="Volvé a Calmar Tu Mente en 21 Días - Libro" className="w-full max-w-xs md:max-w-sm rounded-2xl shadow-xl" data-id="element-79" />
            </motion.div>

            <p className="text-lg md:text-xl text-slate leading-relaxed mb-6 max-w-2xl mx-auto lg:mx-0" data-id="element-80">
              El método paso a paso para bajar la ansiedad, dejar de sobrepensar
              y recuperar tu paz mental — sin terapia, sin pastillas, a tu
              ritmo.
            </p>

            <motion.div className="inline-block mb-8 px-4 py-1.5 rounded-full border border-gold/30 bg-gold/10" initial={{
            opacity: 0,
            scale: 0.9
          }} animate={{
            opacity: 1,
            scale: 1
          }} transition={{
            delay: 0.2,
            duration: 0.5
          }} data-id="element-81">
              <span className="text-gold-dark font-semibold text-xs tracking-wider uppercase" data-id="element-82">
                Incluye 6 bonos premium
              </span>
            </motion.div>

            <motion.button onClick={scrollToCheckout} className="w-full sm:w-auto px-8 py-4 text-beige-light rounded-xl font-medium text-lg shadow-premium hover:shadow-premium-hover hover:-translate-y-1 transition-all duration-300 border border-gold/20 bg-[#B08D4C]" whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} data-id="element-83">
              QUIERO EL MÉTODO
            </motion.button>

            <div className="mt-6 flex flex-wrap items-center justify-center lg:justify-start gap-4 text-sm text-slate-light" data-id="element-84">
              <div className="flex items-center gap-1.5" data-id="element-85">
                <Lock size={16} className="text-gold" data-id="element-86" />
                <span data-id="element-87">Acceso inmediato</span>
              </div>
              <span className="hidden sm:inline text-slate-light/50" data-id="element-88">•</span>
              <div className="flex items-center gap-1.5" data-id="element-89">
                <ShieldCheck size={16} className="text-gold" data-id="element-90" />
                <span data-id="element-91">Garantía 7 días</span>
              </div>
              <span className="hidden sm:inline text-slate-light/50" data-id="element-92">•</span>
              <div className="flex items-center gap-1.5" data-id="element-93">
                <Clock size={16} className="text-gold" data-id="element-94" />
                <span data-id="element-95">Pago 100% seguro con Mercado Pago</span>
              </div>
            </div>
          </motion.div>

          {/* Mockup */}
          <motion.div className="flex-1 w-full max-w-md lg:max-w-none relative" initial={{
          opacity: 0,
          x: 20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.8,
          delay: 0.3
        }} data-id="element-96">
            {/* Decorative background circle */}
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[120%] aspect-square bg-gold/5 rounded-full blur-3xl -z-10" data-id="element-97"></div>
          </motion.div>
        </div>
      </div>
    </section>;
}